import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Vercel-like: sharp corners, hairline border, subtle focus ring
        "file:text-foreground placeholder:text-muted-foreground/40 selection:bg-foreground selection:text-background border border-border/60 h-9 w-full min-w-0 rounded-none bg-background px-3 py-1 text-base outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "hover:bg-muted/10 focus-visible:ring-2 focus-visible:ring-ring/40",
        "aria-invalid:ring-2 aria-invalid:ring-destructive/25 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
